// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!../../node_modules/postcss-loader/dist/cjs.js!../public/fonts/inter/inter.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 
https://github.com/consta-design-system/uikit/issues/3903
*/
/* stylelint-disable-next-line selector-class-pattern -- класс Consta */
.Theme_color_gpnDefault {
    --color-control-bg-ghost-solid: rgb(237 242 244);
    --color-control-bg-ghost-hover-solid: rgb(242 246 245);
}
/* stylelint-disable-next-line selector-class-pattern -- класс Consta */
.Theme_color_gpnDark {
    --color-control-bg-ghost-solid: rgb(69 73 76);
    --color-control-bg-ghost-hover-solid: rgb(84 88 91);
}

:root {
    --geomate-time-function: cubic-bezier(0.075, 0.82, 0.165, 1);
    --geomate-time-duration: 0.5s;
    --geomate-border-radius: 0.8rem;
}

* {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
}

/* НЕ УБИРАТЬ: детектор попытки использовать несуществующий класс */
.undefined {
    border: 10rem solid hotpink;
}

.app {
    overflow: auto;
    display: flex;
    flex-direction: column;
    height: 100vh;
}

.background {
    position: absolute;

    /* Нужен, иначе перекрывает канвас окна интерпретации */
    z-index: -2;

    width: 100%;
    height: 100%;

    background-color: var(--color-bg-default);
}

html {
    --main-font-size: 10px; /* stylelint-disable-line -- задание значения rem */

    font-size: var(--main-font-size);
}

body {
    overflow: hidden;

    height: 100vh;

    font-family: Roboto, sans-serif;
    font-weight: 400;
    line-height: 1.5;

    background: #fff;
}

body > iframe {
    display: none;
}

/* stylelint-disable-next-line selector-class-pattern -- класс Consta */
.Theme ::-webkit-scrollbar {
    width: 0.8rem;
    height: 0.8rem;
}

/* stylelint-disable selector-class-pattern -- класс Consta */
.Theme ::-webkit-scrollbar-corner,
.Theme ::-webkit-scrollbar-track {
    background-color: var(--color-scroll-bg);
}
/* stylelint-enable selector-class-pattern */

/* stylelint-disable-next-line selector-class-pattern -- класс Consta */
.Theme ::-webkit-scrollbar-thumb {
    background-color: var(--color-scroll-thumb);
    border-radius: 0.4rem;
}

/* stylelint-disable-next-line selector-class-pattern -- Класс RC Table */
.rctr--RcTree-switcher {
    color: var(--color-typo-primary);
}

/* stylelint-disable-next-line selector-class-pattern -- Класс Consta */
div.TextField-InputContainer_view_default.TextField-InputContainer_focus {
    /* У консты есть неприятный default: конкретно этот селектор зачем-то выставляет z-index: 1  */
    z-index: unset;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAEA;;CAEC;AACD,uEAAuE;AACvE;IACI,gDAAgD;IAChD,sDAAsD;AAC1D;AACA,uEAAuE;AACvE;IACI,6CAA6C;IAC7C,mDAAmD;AACvD;;AAEA;IACI,4DAA4D;IAC5D,6BAA6B;IAC7B,+BAA+B;AACnC;;AAEA;IACI,sBAAsB;IACtB,SAAS;IACT,UAAU;AACd;;AAEA,mEAAmE;AACnE;IACI,2BAA2B;AAC/B;;AAEA;IACI,cAAc;IACd,aAAa;IACb,sBAAsB;IACtB,aAAa;AACjB;;AAEA;IACI,kBAAkB;;IAElB,uDAAuD;IACvD,WAAW;;IAEX,WAAW;IACX,YAAY;;IAEZ,yCAAyC;AAC7C;;AAEA;IACI,sBAAsB,EAAE,mDAAmD;;IAE3E,gCAAgC;AACpC;;AAEA;IACI,gBAAgB;;IAEhB,aAAa;;IAEb,+BAA+B;IAC/B,gBAAgB;IAChB,gBAAgB;;IAEhB,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA,uEAAuE;AACvE;IACI,aAAa;IACb,cAAc;AAClB;;AAEA,6DAA6D;AAC7D;;IAEI,wCAAwC;AAC5C;AACA,4CAA4C;;AAE5C,uEAAuE;AACvE;IACI,2CAA2C;IAC3C,qBAAqB;AACzB;;AAEA,yEAAyE;AACzE;IACI,gCAAgC;AACpC;;AAEA,uEAAuE;AACvE;IACI,8FAA8F;IAC9F,cAAc;AAClB","sourcesContent":["@import url('/public/fonts/inter/inter.css');\n\n/* \nhttps://github.com/consta-design-system/uikit/issues/3903\n*/\n/* stylelint-disable-next-line selector-class-pattern -- класс Consta */\n:global(.Theme_color_gpnDefault) {\n    --color-control-bg-ghost-solid: rgb(237 242 244);\n    --color-control-bg-ghost-hover-solid: rgb(242 246 245);\n}\n/* stylelint-disable-next-line selector-class-pattern -- класс Consta */\n:global(.Theme_color_gpnDark) {\n    --color-control-bg-ghost-solid: rgb(69 73 76);\n    --color-control-bg-ghost-hover-solid: rgb(84 88 91);\n}\n\n:root {\n    --geomate-time-function: cubic-bezier(0.075, 0.82, 0.165, 1);\n    --geomate-time-duration: 0.5s;\n    --geomate-border-radius: 0.8rem;\n}\n\n* {\n    box-sizing: border-box;\n    margin: 0;\n    padding: 0;\n}\n\n/* НЕ УБИРАТЬ: детектор попытки использовать несуществующий класс */\n.undefined {\n    border: 10rem solid hotpink;\n}\n\n.app {\n    overflow: auto;\n    display: flex;\n    flex-direction: column;\n    height: 100vh;\n}\n\n.background {\n    position: absolute;\n\n    /* Нужен, иначе перекрывает канвас окна интерпретации */\n    z-index: -2;\n\n    width: 100%;\n    height: 100%;\n\n    background-color: var(--color-bg-default);\n}\n\nhtml {\n    --main-font-size: 10px; /* stylelint-disable-line -- задание значения rem */\n\n    font-size: var(--main-font-size);\n}\n\nbody {\n    overflow: hidden;\n\n    height: 100vh;\n\n    font-family: Roboto, sans-serif;\n    font-weight: 400;\n    line-height: 1.5;\n\n    background: #fff;\n}\n\nbody > iframe {\n    display: none;\n}\n\n/* stylelint-disable-next-line selector-class-pattern -- класс Consta */\n.Theme ::-webkit-scrollbar {\n    width: 0.8rem;\n    height: 0.8rem;\n}\n\n/* stylelint-disable selector-class-pattern -- класс Consta */\n.Theme ::-webkit-scrollbar-corner,\n.Theme ::-webkit-scrollbar-track {\n    background-color: var(--color-scroll-bg);\n}\n/* stylelint-enable selector-class-pattern */\n\n/* stylelint-disable-next-line selector-class-pattern -- класс Consta */\n.Theme ::-webkit-scrollbar-thumb {\n    background-color: var(--color-scroll-thumb);\n    border-radius: 0.4rem;\n}\n\n/* stylelint-disable-next-line selector-class-pattern -- Класс RC Table */\n:global(.rctr--RcTree-switcher) {\n    color: var(--color-typo-primary);\n}\n\n/* stylelint-disable-next-line selector-class-pattern -- Класс Consta */\n:global(div.TextField-InputContainer_view_default.TextField-InputContainer_focus) {\n    /* У консты есть неприятный default: конкретно этот селектор зачем-то выставляет z-index: 1  */\n    z-index: unset;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"undefined": `undefined`,
	"app": `app`,
	"background": `background`,
	"Theme": `Theme`
};
export default ___CSS_LOADER_EXPORT___;
